import type { BaseProps } from 'src/types/utils';

export interface ToastHostProps extends BaseProps {
  className?: string;
}

/**
 * Toast variants used across the app.
 */
export enum ToastType {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  DEFAULT = 'default',
}

export enum ToastDuration {
  DEFAULT = 500,
  LONG = 3000,
}
